<template>
  <div class="error-404">
    <Subheader />
    <h3 class="error">PAGE NOT FOUND</h3>
    <p class="link">
      <router-link :to="{ name: 'Home' }">
        Return Home
      </router-link>
    </p>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'

export default {
  name: 'Error404',
  components: {
    Subheader,
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.error-404 {
  display: flex;
  flex-direction: column;
  height: 50vh;
}

.error {
  margin: 2rem auto;
  font-size: 1.5rem;
  color: $base-gray;
}

.link {
  margin: 0 auto;
  text-decoration: underline;
}
</style>
